module.exports = __webpack_public_path__ + "static/media/star.9179862c.png";